export const viewTitle = "Список системных уведомлений";
export const viewUniqKey = "system-notifications";
